var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { TradeType } from '@uniswap/sdk-core';
import IUniswapV3PoolJson from '@uniswap/v3-core/artifacts/contracts/interfaces/IUniswapV3Pool.sol/IUniswapV3Pool.json';
import NonfungiblePositionManagerABI from '@uniswap/v3-periphery/artifacts/contracts/NonfungiblePositionManager.sol/NonfungiblePositionManager.json';
import { computePoolAddress, nearestUsableTick, Pool, Position, TICK_SPACINGS } from '@uniswap/v3-sdk';
import { NONFUNGIBLE_POSITION_MANAGER_ADDRESSES } from '../../../../constants/addresses';
import { BigNumber, ethers } from 'ethers';
import { Config } from '../../../../Fct/Config';
import { INVALID_TRADE, UNISWAP_TYPE } from '../../../../Fct/plugins/uniswap/helpers';
import getClientSideSmartOrderRouterTrade from '../../../../Fct/plugins/uniswap/helpers/getClientSideSmartOrderRouterTrade';
import { getMethodName } from '../../../../Fct/plugins/uniswap/helpers/getMethodName';
import getSlippage from '../../../../Fct/plugins/uniswap/helpers/getSlippage';
import { Field } from '../../../../Fct/plugins/uniswap/helpers/types/swap';
import { TradeState } from '../../../../Fct/plugins/uniswap/helpers/types/types';
import { weiToCurrency } from '../../../../utils/tryParseCurrencyAmount';
import { IncreaseLiquidity } from '../actions/IncreaseLiquidity';
import { Mint } from '../actions/Mint';
import { FACTORY_ADDRESS } from './constants';
import { getSwapCall } from './getSwapCall';
import { getToken, multicall } from './helpers';
var IUniswapV3PoolABI = IUniswapV3PoolJson.abi;
var REJECT_PREV_REQUEST_ERROR = 'reject previous values';
var UniswapV3 = /** @class */ (function (_super) {
    __extends(UniswapV3, _super);
    function UniswapV3(_a) {
        var chainId = _a.chainId, account = _a.account, provider = _a.provider;
        var _this = _super.call(this, { chainId: chainId, account: account, provider: provider }) || this;
        _this.promiseReject = undefined;
        _this.getSwapParams = function (_a) {
            var input = _a.input, output = _a.output, slippage = _a.slippage;
            return __awaiter(_this, void 0, void 0, function () {
                var swapValues, e_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, this.getLastSwapParamsV3({ input: input, output: output, slippage: slippage })];
                        case 1:
                            swapValues = _b.sent();
                            return [2 /*return*/, swapValues];
                        case 2:
                            e_1 = _b.sent();
                            if (e_1 === REJECT_PREV_REQUEST_ERROR) {
                                return [2 /*return*/, undefined];
                            }
                            throw new Error(e_1);
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        _this.mintPosition = function (_a) {
            var _b;
            var configuredPool = _a.configuredPool, tokenA = _a.tokenA, tokenB = _a.tokenB, priceUpper = _a.priceUpper, priceLower = _a.priceLower, isPriceInverted = _a.isPriceInverted;
            var decimalDiff = configuredPool.token1.decimals - configuredPool.token0.decimals;
            var tickUpper = _this.priceToTick(priceUpper, decimalDiff, isPriceInverted, TICK_SPACINGS[configuredPool.fee]);
            var tickLower = _this.priceToTick(priceLower, decimalDiff, isPriceInverted, TICK_SPACINGS[configuredPool.fee]);
            if (isPriceInverted) {
                ;
                _b = __read([tickLower, tickUpper], 2), tickUpper = _b[0], tickLower = _b[1];
            }
            if (tokenA && tokenA.amount) {
                var position = Position.fromAmount0({
                    pool: configuredPool,
                    tickUpper: tickUpper,
                    tickLower: tickLower,
                    amount0: tokenA.amount,
                    useFullPrecision: true,
                });
                return {
                    amount0: position.amount0.quotient.toString(),
                    amount1: position.amount1.quotient.toString(),
                    liquidity: position.liquidity.toString(),
                    tickLower: position.tickLower,
                    tickUpper: position.tickUpper,
                    plugin: Mint,
                    params: {
                        methodParams: {
                            params_tuple: {
                                token0: configuredPool.token0.address,
                                token1: configuredPool.token1.address,
                                fee: configuredPool.fee,
                                tickLower: position.tickLower,
                                tickUpper: position.tickUpper,
                                amount0Desired: position.amount0.quotient.toString(),
                                amount1Desired: position.amount1.quotient.toString(),
                                amount0Min: '0',
                                amount1Min: '0',
                                recipient: _this.account,
                                deadline: { type: 'global', id: 'blockTimestamp' },
                            },
                        },
                    },
                };
            }
            if (tokenB && tokenB.amount) {
                var position = Position.fromAmount1({
                    pool: configuredPool,
                    tickUpper: tickUpper,
                    tickLower: tickLower,
                    amount1: tokenB.amount,
                });
                return {
                    amount0: position.amount0.quotient.toString(),
                    amount1: position.amount1.quotient.toString(),
                    liquidity: position.liquidity.toString(),
                    tickLower: position.tickLower,
                    tickUpper: position.tickUpper,
                    plugin: Mint,
                    params: {
                        methodParams: {
                            params_tuple: {
                                token0: configuredPool.token0.address,
                                token1: configuredPool.token1.address,
                                fee: configuredPool.fee,
                                tickLower: position.tickLower,
                                tickUpper: position.tickUpper,
                                amount0Desired: position.amount0.quotient.toString(),
                                amount1Desired: position.amount1.quotient.toString(),
                                amount0Min: '0',
                                amount1Min: '0',
                                recipient: _this.account,
                                deadline: { type: 'global', id: 'blockTimestamp' },
                            },
                        },
                    },
                };
            }
            return undefined;
        };
        _this.getAddLiquidity = function (_a) {
            var configuredPool = _a.configuredPool, tokenA = _a.tokenA, tokenB = _a.tokenB, tokenId = _a.tokenId, tickLower = _a.tickLower, tickUpper = _a.tickUpper;
            if (tokenA && tokenA.amount) {
                var position = Position.fromAmount0({
                    pool: configuredPool,
                    tickUpper: tickUpper,
                    tickLower: tickLower,
                    amount0: tokenA.amount,
                    useFullPrecision: true,
                });
                return {
                    amount0: position.amount0.quotient.toString(),
                    amount1: position.amount1.quotient.toString(),
                    plugin: IncreaseLiquidity,
                    params: {
                        methodParams: {
                            params_tuple: {
                                tokenId: tokenId,
                                amount0Desired: position.amount0.quotient.toString(),
                                amount1Desired: position.amount1.quotient.toString(),
                                amount0Min: '0',
                                amount1Min: '0',
                                deadline: { type: 'global', id: 'blockTimestamp' },
                            },
                        },
                    },
                };
            }
            if (tokenB && tokenB.amount) {
                var position = Position.fromAmount1({
                    pool: configuredPool,
                    tickUpper: tickUpper,
                    tickLower: tickLower,
                    amount1: tokenB.amount,
                });
                return {
                    amount0: position.amount0.quotient.toString(),
                    amount1: position.amount1.quotient.toString(),
                    plugin: IncreaseLiquidity,
                    params: {
                        methodParams: {
                            params_tuple: {
                                tokenId: tokenId,
                                amount0Desired: position.amount0.quotient.toString(),
                                amount1Desired: position.amount1.quotient.toString(),
                                amount0Min: '0',
                                amount1Min: '0',
                                deadline: { type: 'global', id: 'blockTimestamp' },
                            },
                        },
                    },
                };
            }
            return undefined;
        };
        _this.fees = [500, 3000, 10000];
        _this.isPairExist = function (_a) {
            var token0 = _a.token0, token1 = _a.token1;
            return __awaiter(_this, void 0, void 0, function () {
                var token0Contract, token1Contract, decimals0, e_2, decimals1, e_3, _b, _c, fee, pool, e_4_1;
                var e_4, _d;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            token0Contract = new ethers.Contract(token0, ['function decimals() view returns (uint8 decimals)'], this.library);
                            token1Contract = new ethers.Contract(token1, ['function decimals() view returns (uint8 decimals)'], this.library);
                            decimals0 = 18;
                            _e.label = 1;
                        case 1:
                            _e.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, token0Contract.decimals()];
                        case 2:
                            decimals0 = _e.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            e_2 = _e.sent();
                            console.error(e_2);
                            return [3 /*break*/, 4];
                        case 4:
                            decimals1 = 18;
                            _e.label = 5;
                        case 5:
                            _e.trys.push([5, 7, , 8]);
                            return [4 /*yield*/, token1Contract.decimals()];
                        case 6:
                            decimals1 = _e.sent();
                            return [3 /*break*/, 8];
                        case 7:
                            e_3 = _e.sent();
                            console.error(e_3);
                            return [3 /*break*/, 8];
                        case 8:
                            _e.trys.push([8, 13, 14, 15]);
                            _b = __values(this.fees), _c = _b.next();
                            _e.label = 9;
                        case 9:
                            if (!!_c.done) return [3 /*break*/, 12];
                            fee = _c.value;
                            return [4 /*yield*/, this.getPoolInstance({
                                    tokenA: {
                                        address: token0,
                                        decimals: decimals0,
                                    },
                                    tokenB: {
                                        address: token1,
                                        decimals: decimals1,
                                    },
                                    fee: fee,
                                })];
                        case 10:
                            pool = _e.sent();
                            if (pool)
                                return [2 /*return*/, {
                                        path: "".concat(token0, "00").concat(BigNumber.from(pool.fee).toHexString().replace('0x', '')).concat(token1.replace('0x', '')),
                                        fee: pool.fee,
                                    }];
                            _e.label = 11;
                        case 11:
                            _c = _b.next();
                            return [3 /*break*/, 9];
                        case 12: return [3 /*break*/, 15];
                        case 13:
                            e_4_1 = _e.sent();
                            e_4 = { error: e_4_1 };
                            return [3 /*break*/, 15];
                        case 14:
                            try {
                                if (_c && !_c.done && (_d = _b.return)) _d.call(_b);
                            }
                            finally { if (e_4) throw e_4.error; }
                            return [7 /*endfinally*/];
                        case 15: return [2 /*return*/, false];
                    }
                });
            });
        };
        _this.getPoolInstance = function (_a) {
            var tokenA = _a.tokenA, tokenB = _a.tokenB, fee = _a.fee;
            return __awaiter(_this, void 0, void 0, function () {
                var poolAddress, token0, token1, tickSpacing, poolContract, _b, liquidity, slot0, pool, e_5;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            poolAddress = this.getPoolAddress({ tokenA: tokenA, tokenB: tokenB, fee: fee });
                            token0 = this.getToken(tokenA);
                            token1 = this.getToken(tokenB);
                            tickSpacing = TICK_SPACINGS[fee];
                            poolContract = new ethers.Contract(poolAddress, IUniswapV3PoolABI, this.library);
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, Promise.all([poolContract.liquidity(), poolContract.slot0()])];
                        case 2:
                            _b = __read.apply(void 0, [_c.sent(), 2]), liquidity = _b[0], slot0 = _b[1];
                            pool = new Pool(token0, token1, fee, slot0.sqrtPriceX96.toString(), liquidity.toString(), slot0.tick);
                            return [2 /*return*/, {
                                    tickSpacing: tickSpacing,
                                    price: pool.priceOf(token0).quotient.toString(),
                                    priceNormalised: pool.priceOf(token0).toSignificant(),
                                    invertedPrice: pool.token1Price.toFixed(),
                                    invertedPriceNormalised: pool.priceOf(token1).toSignificant(),
                                    priceDecimals: pool.token0.decimals - pool.token1.decimals,
                                    tick: pool.tickCurrent,
                                    configuredPool: pool,
                                    fee: pool.fee,
                                }];
                        case 3:
                            e_5 = _c.sent();
                            console.error('Pool not found');
                            return [2 /*return*/];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        _this.getPosition = function (tokenId) { return __awaiter(_this, void 0, void 0, function () {
            var position;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.NFTManagerContract.positions(tokenId)];
                    case 1:
                        position = _a.sent();
                        return [2 /*return*/, __assign({}, position)];
                }
            });
        }); };
        _this.getPoolAddress = function (_a) {
            var tokenA = _a.tokenA, tokenB = _a.tokenB, fee = _a.fee;
            return computePoolAddress({
                factoryAddress: FACTORY_ADDRESS,
                tokenA: _this.getToken(tokenA),
                tokenB: _this.getToken(tokenB),
                fee: fee,
            });
        };
        _this.getUserPositions = function (account) { return __awaiter(_this, void 0, void 0, function () {
            var balance, tokenIDsCalls, tokenIDs, positionsCalls, positions;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.NFTManagerContract.balanceOf(account)];
                    case 1:
                        balance = _a.sent();
                        if (balance.toNumber() === 0) {
                            return [2 /*return*/, []];
                        }
                        tokenIDsCalls = Array.from(Array(balance.toNumber()).keys()).map(function (i) {
                            return {
                                target: _this.NFTManagerContract.address,
                                callData: _this.NFTManagerContract.interface.encodeFunctionData('tokenOfOwnerByIndex', [account, i]),
                                returnTypes: [{ name: 'tokenId', type: 'uint256' }],
                            };
                        });
                        return [4 /*yield*/, multicall(tokenIDsCalls, this.library, this.chainId)];
                    case 2:
                        tokenIDs = _a.sent();
                        positionsCalls = tokenIDs.map(function (value) {
                            return {
                                target: _this.NFTManagerContract.address,
                                callData: _this.NFTManagerContract.interface.encodeFunctionData('positions', [value.tokenId]),
                                returnTypes: [
                                    { name: 'nonce', type: 'uint96' },
                                    { name: 'operator', type: 'address' },
                                    { name: 'token0', type: 'address' },
                                    { name: 'token1', type: 'address' },
                                    { name: 'fee', type: 'uint24' },
                                    { name: 'tickLower', type: 'int24' },
                                    { name: 'tickUpper', type: 'int24' },
                                    { name: 'liquidity', type: 'uint128' },
                                    { name: 'feeGrowthInside0LastX128', type: 'uint256' },
                                    { name: 'feeGrowthInside1LastX128', type: 'uint256' },
                                    { name: 'tokensOwed0', type: 'uint128' },
                                    { name: 'tokensOwed1', type: 'uint128' },
                                ],
                            };
                        });
                        return [4 /*yield*/, multicall(positionsCalls, this.library, this.chainId)];
                    case 3:
                        positions = _a.sent();
                        return [2 /*return*/, positions.map(function (position, i) {
                                return __assign(__assign({}, position), { tokenId: tokenIDs[i].tokenId });
                            })];
                }
            });
        }); };
        _this.priceToTick = function (price, decimalDiff, isPriceInverted, tickSpacing) {
            if (isPriceInverted === void 0) { isPriceInverted = false; }
            var p = !isPriceInverted ? parseFloat(price) : 1 / parseFloat(price);
            return nearestUsableTick(Math.floor(Math.log(p * Math.pow(10, decimalDiff)) / Math.log(1.0001)), tickSpacing);
        };
        _this.getToken = function (swapToken) {
            var chainId = _this.chainId;
            return getToken(swapToken, chainId);
        };
        _this.getLastSwapParamsV3 = function (_a) {
            var input = _a.input, output = _a.output, slippage = _a.slippage;
            return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                var _b;
                return __generator(this, function (_c) {
                    (_b = this.promiseReject) === null || _b === void 0 ? void 0 : _b.call(this, REJECT_PREV_REQUEST_ERROR);
                    return [2 /*return*/, new Promise(function (resolve, regect) { return __awaiter(_this, void 0, void 0, function () {
                            var values;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        this.promiseReject = regect;
                                        return [4 /*yield*/, this.getSwapValuesV3({ input: input, output: output, slippage: slippage })];
                                    case 1:
                                        values = _a.sent();
                                        resolve(values);
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                });
            });
        };
        _this.getSwapValuesV3 = function (_a) {
            var input = _a.input, output = _a.output, slippage = _a.slippage;
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    return [2 /*return*/, this.getSwapValues({
                            input: input,
                            output: output,
                            protocol: 'V3',
                            slippage: slippage,
                        })];
                });
            });
        };
        _this.getTradeState = function (stateindex) {
            switch (stateindex) {
                case 3:
                    return 'VALID';
                default:
                    return 'INVALID';
            }
        };
        _this.getSwapValues = function (_a) {
            var input = _a.input, output = _a.output, protocol = _a.protocol, slippage = _a.slippage;
            return __awaiter(_this, void 0, void 0, function () {
                var _b, library, account, chainId, currencyIn, currencyOut, isExactIn, blockTimestamp, swapInfo, swapCall, params, methodName, swap;
                var _c, _d, _e;
                return __generator(this, function (_f) {
                    switch (_f.label) {
                        case 0:
                            if (!input.currency) {
                                throw new Error('input currency required');
                            }
                            if (!output.currency) {
                                throw new Error('output currency required');
                            }
                            if (!input.amount && !output.amount) {
                                return [2 /*return*/, {
                                        inputAmount: '0',
                                        outputAmount: '0',
                                        state: 'INVALID',
                                        params: undefined,
                                        INPUT: {
                                            currency: undefined,
                                            amount: undefined,
                                        },
                                        OUTPUT: {
                                            currency: undefined,
                                            amount: undefined,
                                        },
                                        trade: undefined,
                                        slippage: undefined,
                                        type: undefined,
                                        methodName: undefined,
                                        protocol: 'UNISWAP',
                                    }];
                            }
                            _b = this, library = _b.library, account = _b.account, chainId = _b.chainId;
                            currencyIn = this.getToken(input.currency);
                            currencyOut = this.getToken(output.currency);
                            isExactIn = Boolean(input.amount);
                            return [4 /*yield*/, this.getLastBlock()];
                        case 1:
                            blockTimestamp = (_f.sent()).blockTimestamp;
                            return [4 /*yield*/, this.getSwapInfo({
                                    amount: input.amount || output.amount || '0',
                                    currencyIn: currencyIn,
                                    currencyOut: currencyOut,
                                    isExactIn: isExactIn,
                                    protocol: protocol,
                                    slippage: slippage,
                                })];
                        case 2:
                            swapInfo = _f.sent();
                            return [4 /*yield*/, getSwapCall({ library: library, chainId: chainId, account: account, swapInfo: swapInfo, blockTimestamp: blockTimestamp, protocol: protocol })];
                        case 3:
                            swapCall = _f.sent();
                            params = swapCall === null || swapCall === void 0 ? void 0 : swapCall.params;
                            methodName = getMethodName({
                                isExactInput: isExactIn,
                                isInputNative: this.getToken(input.currency).isNative,
                                isOutputNative: this.getToken(output.currency).isNative,
                                protocol: protocol,
                                params: params,
                            });
                            swap = __assign(__assign({}, swapInfo), { inputAmount: (_c = swapInfo.INPUT.amount) === null || _c === void 0 ? void 0 : _c.quotient.toString(10), outputAmount: (_d = swapInfo.OUTPUT.amount) === null || _d === void 0 ? void 0 : _d.quotient.toString(10), state: this.getTradeState(((_e = swapInfo === null || swapInfo === void 0 ? void 0 : swapInfo.trade) === null || _e === void 0 ? void 0 : _e.state) || 0), params: {
                                    methodParams: swapCall === null || swapCall === void 0 ? void 0 : swapCall.params,
                                }, methodName: methodName, protocol: 'UNISWAP' });
                            return [2 /*return*/, swap];
                    }
                });
            });
        };
        _this.getSwapInfo = function (_a) {
            var amount = _a.amount, currencyIn = _a.currencyIn, currencyOut = _a.currencyOut, protocol = _a.protocol, isExactIn = _a.isExactIn, slippage = _a.slippage;
            return __awaiter(_this, void 0, void 0, function () {
                var parsedAmount, hasAmounts, trade, amountIn, amountOut;
                var _b;
                var _c, _d, _e;
                return __generator(this, function (_f) {
                    switch (_f.label) {
                        case 0:
                            parsedAmount = weiToCurrency(amount, (_c = (isExactIn ? currencyIn : currencyOut)) !== null && _c !== void 0 ? _c : undefined);
                            hasAmounts = currencyIn || currencyOut;
                            return [4 /*yield*/, this.getBestTrade({
                                    tradeType: isExactIn ? TradeType.EXACT_INPUT : TradeType.EXACT_OUTPUT,
                                    protocol: protocol,
                                    amountSpecified: hasAmounts ? parsedAmount : undefined,
                                    otherCurrency: isExactIn ? currencyOut : currencyIn,
                                })];
                        case 1:
                            trade = _f.sent();
                            amountIn = isExactIn ? parsedAmount : (_d = trade === null || trade === void 0 ? void 0 : trade.trade) === null || _d === void 0 ? void 0 : _d.inputAmount //isWrapping || isExactIn ? parsedAmount : trade.trade?.inputAmount
                            ;
                            amountOut = !isExactIn ? parsedAmount : (_e = trade === null || trade === void 0 ? void 0 : trade.trade) === null || _e === void 0 ? void 0 : _e.outputAmount //isWrapping || !isExactIn ? parsedAmount : trade.trade?.outputAmount
                            ;
                            return [2 /*return*/, (_b = {},
                                    _b[Field.INPUT] = {
                                        currency: currencyIn,
                                        amount: amountIn,
                                    },
                                    _b[Field.OUTPUT] = {
                                        currency: currencyOut,
                                        amount: amountOut,
                                    },
                                    _b.trade = trade,
                                    _b.slippage = getSlippage(slippage),
                                    _b.type = isExactIn ? UNISWAP_TYPE.EXACT_INPUT : UNISWAP_TYPE.EXACT_OUTPUT,
                                    _b)];
                    }
                });
            });
        };
        /**
         * Returns the best v2+v3 trade for a desired swap.
         * @param tradeType whether the swap is an exact in/out
         * @param amountSpecified the exact amount to swap in/out
         * @param otherCurrency the desired output/payment currency
         */
        _this.getBestTrade = function (_a) {
            var tradeType = _a.tradeType, amountSpecified = _a.amountSpecified, protocol = _a.protocol, otherCurrency = _a.otherCurrency;
            return __awaiter(_this, void 0, void 0, function () {
                var library, clientSORTradeObject, tradeObject, lastTrade, state, trade, _b, currencyIn, currencyOut, isStale;
                var _c, _d;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            library = this.library;
                            return [4 /*yield*/, getClientSideSmartOrderRouterTrade({
                                    library: library,
                                    tradeType: tradeType,
                                    protocol: protocol,
                                    amountSpecified: amountSpecified,
                                    otherCurrency: otherCurrency,
                                })];
                        case 1:
                            clientSORTradeObject = _e.sent();
                            tradeObject = clientSORTradeObject;
                            lastTrade = tradeObject === null || tradeObject === void 0 ? void 0 : tradeObject.trade;
                            // Return the last trade while syncing/loading to avoid jank from clearing the last trade while loading.
                            // If the trade is unsettled and not stale, return the last trade as a placeholder during settling.
                            if (!tradeObject)
                                return [2 /*return*/];
                            state = tradeObject.state, trade = tradeObject.trade;
                            // If the trade is in a settled state, return it.
                            if (state === TradeState.INVALID)
                                return [2 /*return*/, INVALID_TRADE];
                            if ((state !== TradeState.LOADING && state !== TradeState.SYNCING) || trade)
                                return [2 /*return*/, tradeObject];
                            _b = __read(tradeType === TradeType.EXACT_INPUT
                                ? [amountSpecified === null || amountSpecified === void 0 ? void 0 : amountSpecified.currency, otherCurrency]
                                : [otherCurrency, amountSpecified === null || amountSpecified === void 0 ? void 0 : amountSpecified.currency], 2), currencyIn = _b[0], currencyOut = _b[1];
                            isStale = (currencyIn && !((_c = lastTrade === null || lastTrade === void 0 ? void 0 : lastTrade.inputAmount) === null || _c === void 0 ? void 0 : _c.currency.equals(currencyIn))) ||
                                (currencyOut && !((_d = lastTrade === null || lastTrade === void 0 ? void 0 : lastTrade.outputAmount) === null || _d === void 0 ? void 0 : _d.currency.equals(currencyOut)));
                            if (isStale)
                                return [2 /*return*/, tradeObject];
                            return [2 /*return*/, { state: state, trade: lastTrade }];
                    }
                });
            });
        };
        _this.NFTManagerContract = new ethers.Contract(NONFUNGIBLE_POSITION_MANAGER_ADDRESSES[_this.chainId], NonfungiblePositionManagerABI.abi, _this.library);
        return _this;
    }
    return UniswapV3;
}(Config));
export { UniswapV3 };
